import {
  BooleanField,
  Show,
  TextField,
  SimpleShowLayout,
  NumberField,
} from "react-admin";
import { LocationButton } from "../location/locationButton";

export const DoctorShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="vicinity" />
        <NumberField source="rating" />
        <TextField source="website" />
        <TextField source="formattedPhoneNumber" />
        <BooleanField source="recommended" />
        <LocationButton />
      </SimpleShowLayout>
    </Show>
  );
};
